import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  id: "performance_line",
  style: {"width":"100%","height":"500px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("全部全选")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("链接")
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "always" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode("div", null, [
                    _createVNode(_component_el_form, { inline: true }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "选择场景" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.selected_scene,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_scene = $event)),
                              filterable: "",
                              placeholder: "请选择场景",
                              onChange: _ctx.selectSceneChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.scene_id,
                                    label: item.chinese,
                                    value: item.scene_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "选择机型" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.selected_device,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected_device = $event)),
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                              placeholder: "请选择机型",
                              onChange: _ctx.selectChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, {
                                  justify: "space-around",
                                  type: "flex"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tag, {
                                      type: "primary",
                                      class: "select-tag-class",
                                      onClick: _ctx.handleClearAll
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_1
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_el_tag, {
                                      type: "primary",
                                      class: "select-tag-class",
                                      onClick: _ctx.handleSelectAll
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_2
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_echart_options, (group) => {
                                  return (_openBlock(), _createBlock(_component_el_option_group, {
                                    key: group.label,
                                    label: group.label
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "性能指标" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.selected_target,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected_target = $event)),
                              filterable: "",
                              placeholder: "请选择性能指标",
                              onChange: _ctx.selectChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.onClear
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ])
                ]),
                _: 1
              }),
              _hoisted_5,
              _withDirectives(_createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, { inline: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_space, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "选择场景" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_scene,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                filterable: "",
                                placeholder: "请选择场景",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_row, {
                                    justify: "space-around",
                                    type: "flex"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClearTableAll('selected_table_scene')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_6
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectTableAll('selected_table_scene')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_7
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id,
                                      label: item.chinese,
                                      value: item.scene_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择机型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_device,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selected_table_device = $event)),
                                multiple: "",
                                filterable: "",
                                "collapse-tags": "",
                                placeholder: "请选择机型",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_row, {
                                    justify: "space-around",
                                    type: "flex"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleClearTableAll('selected_table_device')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_8
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectTableAll('selected_table_device')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_9
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                                    return (_openBlock(), _createBlock(_component_el_option_group, {
                                      key: group.label,
                                      label: group.label
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "选择版本" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selected_table_version,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selected_table_version = $event)),
                                multiple: "",
                                filterable: "",
                                "collapse-tags": "",
                                placeholder: "请选择版本",
                                onChange: _ctx.selectTableChange
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_row, {
                                    justify: "space-around",
                                    type: "flex"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleClearTableAll('selected_table_version')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_10
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSelectTableAll('selected_table_version')))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_11
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { style: {"width":"230px"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onTableClear()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onTableAll()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    border: "",
                    data: _ctx.get_table_data.results,
                    style: {"width":"100%"},
                    "max-height": "1000",
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.performance_table_fields, (item) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item.prop,
                          label: item.label,
                          prop: item.prop,
                          align: "center"
                        }, null, 8, ["label", "prop"]))
                      }), 128)),
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        label: "有效",
                        prop: "is_valid",
                        width: "60",
                        fixed: "right"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: scope.row.is_valid,
                            "onUpdate:modelValue": ($event: any) => (scope.row.is_valid = $event),
                            disabled: _ctx.get_is_super,
                            onChange: ($event: any) => (_ctx.IsValidChange(scope.row))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "详情",
                        prop: "url",
                        width: "60",
                        fixed: "right"
                      }, {
                        default: _withCtx((scope) => [
                          (scope.row.url)
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 0,
                                href: _ctx.get_url(scope.row.url),
                                type: "primary",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 2
                              }, 1032, ["href"]))
                            : (_openBlock(), _createBlock("span", _hoisted_15, "-"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_el_footer, { class: "footerStyle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_pagination, {
                        onCurrentChange: _ctx.handleCurrentChange,
                        currentPage: _ctx.current_page,
                        "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => (_ctx.current_page = $event)),
                        "page-size": 16,
                        layout: "total, prev, pager, next",
                        total: _ctx.get_table_data.count
                      }, null, 8, ["onCurrentChange", "currentPage", "total"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.table_loading]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}